import moment from 'moment';

export const dateFormat = (date, format) => {
  return moment(date || new Date(0).toUTCString()).format(format);
};
